export function CalcDistRight(theLayout, pageLayoutMgr) {
  var pageWidth = pageLayoutMgr.GetPageWidth();

  var x = theLayout.GetPositionX();
  var distRight = pageWidth - x;

  return distRight;
}
